import { render, staticRenderFns } from "./PrintTipax.vue?vue&type=template&id=5b4e6322&scoped=true"
import script from "./PrintTipax.vue?vue&type=script&lang=js"
export * from "./PrintTipax.vue?vue&type=script&lang=js"
import style0 from "./PrintTipax.vue?vue&type=style&index=0&id=5b4e6322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e6322",
  null
  
)

export default component.exports